<div class="center" style="background-image: url('../../../assets/Flag1.jpg'); background-size:100% 100%; background-position: bottom;">
    <div>
        <img src="assets/HomeLogo.png" width="125px" height="125px">
    </div>
    <div>
        <h5 class="center" style="color: #1f2d8a; font-weight: bold;">MILITARY ENGINEER SERVICES</h5>
        <h5 style="color: #1f2d8a; font-weight: bold;">CHIEF ENGINEER (NAVAL WORKS) - KOCHI ZONE</h5>
    </div>
</div>
<div id="wrapper">
    <div class="main-content">
        <div class="header center">
            <h2 style="color: #1f2d8a;">Login</h2>
        </div>
        <div class="l-part">
            <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" [(ngModel)]="userName" autocomplete="new-username" autocorrect="off" readonly
                 onfocus="this.removeAttribute('readonly')"
                spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
                <button mat-icon-button matSuffix>
                    <mat-icon matSuffix>person</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Password" [type]="hide() ? 'password' : 'text'" [(ngModel)]="password" 
                    autocomplete="new-password" autocorrect="off" onfocus="this.value=''"
                                spellcheck="false" (copy)="false" (cut)="false" (paste)="false"/>

                <button mat-icon-button matSuffix (click)="clickEvent($event)" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide()">
                    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
            <div class="center">
                <ngx-turnstile [siteKey]="'0x4AAAAAAAkPiEx2XU2Pm46_'" 
                    (resolved)="sendCaptchaResponse($event)"
                    theme="light">
                </ngx-turnstile>
            </div>
            <div class="center" style="margin-top: 15px;">
                <span>
                    <button mat-flat-button [disabled]="disableSignInButton" (click)="saveLogin()">Sign In</button>
                </span>
                <span style="margin-left: 10px;">
                    <button mat-flat-button (click)="goToSignUp()">Sign Up</button>
                </span>
            </div>
            <div class="center" style="margin-top: 10px;">
                <button mat-button (click)="goToForgotPassword()">Forgot Password?</button>
            </div>
        </div>
    </div>
    <div class="center" style="margin-top: 30px; color: blue;">
        <a href="assets/infoFiles/TermsKochi.html" class="no-underline" style="color: blue; margin-right: 10px; text-decoration: none;">Terms of Usage</a>
        <span style="color: red;">|</span>
        <a href="assets/infoFiles/DiscKochi.html" class="no-underline" style="color: blue; margin-right: 10px; margin-left: 10px; text-decoration: none;">Disclaimer</a>
        <span style="color: red;">|</span>
        <a href="assets/infoFiles/KochiAboutUs.html" class="no-underline" style="color: blue; margin-right: 10px; margin-left: 10px; text-decoration: none;">Contact Us</a>
    </div>
    
</div>